<template>
  <section v-maximizable>
    <div class="table-tab">
    <div class="table-tab__container" style="overflow-x: auto">
      <table class="table-tab__block table" style="min-width: 1500px">
        <thead class="table-tab__thead">
          <tr class="">
            <th class="table-tab__border-bottom table-tab__th--row table-tab__border-right"></th>
            <th class="table-tab__border-bottom">
              {{$t('form.lot.parts.date')}}
            </th>
            <th class="table-tab__border-bottom">
              {{$t('form.lot.parts.date-in-bid')}}
            </th>
            <th class="table-tab__border-bottom">
              Дата приемки в предложении Участника
            </th>
            <th class="table-tab__border-bottom">
              {{$t('form.lot.start-date-of-stage-for-delivery')}}
            </th>
            <th class="table-tab__border-bottom">
              {{$t('form.lot.start-date-of-stage-for-payment')}}
            </th>
            <th class="table-tab__border-bottom">
              № предложения исключения
            </th>
            <th class="table-tab__border-bottom">
              Название контрагента предложения исключения
            </th>
          </tr>
        </thead>
        <tbody class="table-tab__tbody">
        <template v-for="(item, itemIdx) in schedule">
          <tr class="table-tab__border-bottom">
            <th class=" table-tab__th--row table-tab__border-bottom table-tab__border-right table-tab__btn-open">
              <span :class="{'row-marker': item.isAdditional}"></span>
              <span class="table-tab__color u-padding-left-30">{{$t('form.lot.parts.part-number', {id: item.partId})}}</span>
            </th>

            <td>
              <label class="a-checkbox__label">
                <input class="a-checkbox__input"
                       type="checkbox"
                       v-model="item.check"
                       @change="onDateCheckChange(item)"
                       :disabled="!canEdit">
                <span class="a-checkbox__icon"><i></i></span>
              </label>
            </td>

            <td class="a-form-field" v-if="item.check">
              <date-picker :value="item.date"
                           @change="onDeliveryDateChange($event, item)"
                           :placeholder="$t('form.retend.specification-configuration.will-be-filled-by-participant')"
                           v-if="canEdit"></date-picker>
              <date-time :value="item.date" :time="false" v-else></date-time>
            </td>
            <td v-else-if="canEdit" class="a-form-field" :class="{'a-input-group--error': $v.schedule.$each[itemIdx].date.$anyError}">
              <date-picker :value="item.date"
                           class="a-input a-input--disabled select-w-260"
                           :placeholder="$t('form.retend.specification-configuration.choose-date')"
                           @change="onDeliveryDateChange($event, item)"></date-picker>
              <span class="a-validation-error" v-if="!$v.schedule.$each[itemIdx].date.validDate">не ранее {{item.minDeliveryDate|moment('DD.MM.YYYY')}}</span>
            </td>
            <td v-else>
              <date-time :value="item.date" :time="false"></date-time>
            </td>

            <td class="a-form-field" v-if="item.check">
              <date-time :value="item.commonReceiveDate"
                         :time="false"
                         :placeholder="$t('form.retend.specification-configuration.will-be-filled-by-participant')"></date-time>
            </td>
            <td v-else-if="canEdit" :class="{'a-input-group--error': $v.schedule.$each[itemIdx].commonReceiveDate.$anyError}">
              <date-picker v-model="item.commonReceiveDate"
                           class="select-w-260"
                           :placeholder="$t('form.retend.specification-configuration.choose-date')"
                           @change="onReceiveDateChange($event, item)"></date-picker>
            </td>
            <td v-else>
              <date-time :value="item.commonReceiveDate" :time="false"></date-time>
            </td>

            <td>
              <date-time :time="false" :value="item.minDeliveryDateByRules"></date-time>
            </td>

            <td>
              <date-time :time="false" :value="item.minPaymentDate"></date-time>
            </td>

            <td>
              <router-link class="table-tab__color u-text-underline"
                           v-if="item.isAdditional"
                           :to="{name: 'purchases-public-lot-alien-bid', params: { lotId: lotCatalog.id, requestId: item.request, bidId: item.bidId, tab: 'bid'}}">
                {{lotCatalog.num}} - {{item.request}} - {{item.bidNum}}
              </router-link>
            </td>

            <td>
              {{item.organization}}
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
  </div>
  </section>
</template>

<script>
  export default {
    props: {
      schedule: {
        type: Array,
        required: true
      },

      canEdit: {
        type: Boolean,
        required: false
      },

      lotCatalog: {
        type: Object,
        required: true
      }
    },

    validations: {
      schedule: {
        $each: {
          date: {
            validDate(value, part) {
              if (part.date && part.minDeliveryDate && part.date < part.minDeliveryDate) return false;
              return true;
            }
          },

          commonReceiveDate: {
            validDate(value, part) {
              return !part.date || part.commonReceiveDate >= part.date;
            }
          }
        }
      }
    },

    created() {
      this.$v.$touch();
    },

    methods: {
      onChange() {
        this.$emit('update', this.schedule);
      },

      onDateCheckChange(item, submit = true) {
        if (item.check) {
          this.onDeliveryDateChange(item.date, item, false);
        }

        if (submit) {
          this.onChange();
        }
      },

      onDeliveryDateChange(value, item, submit = true) {
        item.date = value;

        if (item.check) {
          this.onReceiveDateChange(value, item, false);
        }

        if (item.date) {
          item.deliveryDate.value = item.date;
          item.deliveryDate.precision = new this.enums.Precision(this.enums.Precision.EXACTLY)
        }

        if (submit) {
          this.onChange();
        }
      },

      onReceiveDateChange(value, item, submit = true) {
        item.commonReceiveDate = value;

        if (item.commonReceiveDate) {
          item.receiveDate.value = item.commonReceiveDate;
          item.receiveDate.precision = new this.enums.Precision(this.enums.Precision.EXACTLY)
        }

        if (submit) {
          this.onChange();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .row-marker {
    width: 10px;
    height: 100%;
    background: #E30613;
    position: absolute;
    left: 0;
    top: 0;
    border: none;
  }
</style>
